import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "../features/filter/filterSlice";

const Pagination = () => {
  const { totalTransactions, loading } = useSelector((state) => state.transaction);
  const { loadingType } = loading;
  const dispatch = useDispatch();
  const { page, limit } = useSelector((state) => state.filter);
  const totalPage = totalTransactions ? Math.ceil(totalTransactions / limit) : 0;
  const elements = [];

  const handlePagination = (currentPage) => {
    dispatch(setPage(currentPage));
  };

  for (let i = 1; i <= totalPage; i++) {
    elements.push(
      <button key={i} className={`page-button ${i === page && "selected"}`} onClick={() => handlePagination(i)}>
        {i}
      </button>
    );
  }
  return totalPage > 1 && loadingType !== "fetchTransactions" ? <div className='pagination'>{elements}</div> : null;
};

export default Pagination;
